var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"logo"},[_c('Logo')],1),_c('div',{staticClass:"card"},[_c('SystemUpdates')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }